// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import LightTimeline from 'vue-light-timeline'
import 'babel-polyfill'

import Meta from 'vue-meta'


Vue.use(LightTimeline)   //时间线组件
Vue.config.productionTip = false
Vue.use(ElementUI, { locale })


Vue.use(Meta) //自定义meta头

router.beforeEach((to,from,next) => {
   if(/\//.test(to.path)){ 
          localStorage.setItem('active','1')
        }
    if(/about/.test(to.path)){	
          localStorage.setItem('active','2-1')
        }
     if(/logistics/.test(to.path)){
         
           localStorage.setItem('active','3-1')  //判断头部选中的状态
        }
       if(/business/.test(to.path)){
         
           localStorage.setItem('active','4-1')  //判断头部选中的状态
        }

         if(/solve/.test(to.path)){
        
           localStorage.setItem('active','5-1')
        }
          if(/case/.test(to.path)){
        
           localStorage.setItem('active','6')
        }
          if(/fnews/.test(to.path)){
         
           localStorage.setItem('active','7-1')
        }
          if(/recruit/.test(to.path)){
          	 localStorage.setItem('active','8-1')
         
        }
          if(/contactUs/.test(to.path)){
        
           localStorage.setItem('active','9-1')
        }
  		next()
  })

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js